var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderPartial'),_vm._v(" "),(true)?_c('router-view',_vm._b({},'router-view',_vm.childProps,false)):_vm._e(),_vm._v(" "),_c('FooterPartial'),_vm._v(" "),_c('CookiesBannerPartial'),_vm._v(" "),_c('CookiesManagerPartial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }